module.exports = __webpack_public_path__ + "08903fb597f22c1bdf8dc5bad8594a57.MP3";